/**
 * NoticeList
 * --
 */
import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Table, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import MessageAlert, { strCut } from 'utils';
import moment from 'moment';
import { NoticeApi } from 'api';

/**----------------------------------------
 * [Component] 홈 > 매장별 매출 차트
 * ----------------------------------------
 */
const NoticeList = ({ permission, shopType, isMobile }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [noticeList, setNoticeList] = useState([]);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 공지사항 조회
   * --------------------
   */
  const getNoticeList = async () => {
    try {
      const { status, message, data } = await NoticeApi.getNotices();
      if (status !== 200) throw { message };
      setNoticeList(data);
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getNoticeList();
  }, []);

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <>
      <Spin spinning={loading}>
        <Content
          maxWidth={'100%'}
          height={320}
          borderRadius={4}
          // padding={'14px 5px'}
        >
          <Title
            size={5}
            style={{ marginBottom: 12, fontSize: isMobile ? 14 : 16 }}
            subButton={
              !shopType ? (
                <Button
                  size="small"
                  onClick={() => window.open('/notice/list', '_blank')}
                >
                  <ExportOutlined /> 공지관리
                </Button>
              ) : null
            }
          >
            공지사항
          </Title>

          <Table
            bordered
            size="small"
            scroll={{ x: 'max-content', y: 210 }}
            // style={{ height: 300 }}
            pagination={false}
            dataSource={noticeList.slice(0, 5) ?? []}
            columns={[
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    등록일(시간)
                  </p>
                ),
                dataIndex: 'created_at',
                width: isMobile ? 100 : 200,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {moment(v * 1000).format(
                      isMobile ? 'YY.MM.DD (HH:mm)' : 'YYYY-MM-DD (HH:mm:ss)'
                    )}
                  </p>
                ),
              },
              {
                title: (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    공지사항
                  </p>
                ),
                dataIndex: 'notice_name',
                // width: 220,
                align: 'center',
                render: (v) => (
                  <p
                    style={{
                      lineHeight: '135%',
                      fontSize: isMobile ? '0.7em' : '1em',
                    }}
                  >
                    {strCut(v, 100)}
                  </p>
                ),
              },
              ...(permission === 'ADMIN'
                ? [
                    ({
                      title: (
                        <p
                          style={{
                            lineHeight: '135%',
                            fontSize: isMobile ? '0.7em' : '1em',
                          }}
                        >
                          대상
                        </p>
                      ),
                      dataIndex: 'show_target',
                      width: isMobile ? 80 : 125,
                      align: 'center',
                      render: (value) => (
                        <p
                          style={{
                            lineHeight: '135%',
                            fontSize: isMobile ? '0.7em' : '1em',
                          }}
                        >
                          {value === 'ADMIN' ? '관리자' : '전체'}
                        </p>
                      ),
                    },
                    {
                      title: (
                        <p
                          style={{
                            lineHeight: '135%',
                            fontSize: isMobile ? '0.7em' : '1em',
                          }}
                        >
                          노출
                        </p>
                      ),
                      dataIndex: 'is_show',
                      width: isMobile ? 80 : 125,
                      align: 'center',
                      render: (value) => (
                        <p
                          style={{
                            lineHeight: '135%',
                            fontSize: isMobile ? '0.7em' : '1em',
                          }}
                        >
                          {value === 'Y' ? '노출됨' : '미노출'}
                        </p>
                      ),
                    }),
                  ]
                : []),
            ]}
          />
        </Content>
      </Spin>
    </>
  ); // JSX: end
};

NoticeList.defaultProps = {
  onSelect: () => {},
};
export default NoticeList;
